import _ from 'underscore';

/**
 * Debounce the given function separatley based on the first argument given to the debounced function
 *
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} [immediate]
 * @return {function(...[*])}
 */
export default function memoizedDebounce(func, wait, immediate) {
    const debouncedFuncs = new Map();
    return (...args) => {
        const [key] = args;

        if (!debouncedFuncs.has(key)) {
            debouncedFuncs.set(key, _.debounce((...debounceArgs) => {
                debouncedFuncs.delete(key); // Clear debounced function to save memory. Does this make sense?
                func(...debounceArgs);
            }, wait, immediate));
        }

        return debouncedFuncs.get(key)(...args);
    };
}
